<template>
	<v-container v-if="show" grid-list-xl>
		<v-layout
			row
			justify-center
		>
			<v-flex
				xs12
				md8
				pa-0
			>
				<slot name="alert" />
			</v-flex>
		</v-layout>
		<NewItem
			v-if="$userCan('manage_users') && !project.isArchived"
			ref="newItem"
			button-title="Invite New"
			:loading="sendingInvitation"
		>
			<template slot="form">
				<v-form
					ref="form"
					v-model="valid"
					@submit.prevent="submit"
				>
					<v-layout
						row
						wrap
						ma-0
						justify-center
						align-center
					>
						<v-flex
							xs12
							sm9
							py-0
						>
							<v-text-field
								:disabled="sendingInvitation"
								v-model="inviteName"
								:rules="[...validate.require, validate.max(inviteName, 35)]"
								name="Name"
								label="Name"
							/>
							<v-text-field
								:disabled="sendingInvitation"
								v-model="inviteEmail"
								:rules="[validate.email]"
								name="Email"
								label="Email"
							/>
						</v-flex>
						<v-flex
							xs12
							sm3
							class="text-xs-center"
						>
							<v-btn
								:disabled="!valid || sendingInvitation"
								color="primary"
								type="submit"
							>
								submit
							</v-btn>
							<v-btn
								:disabled="sendingInvitation"
								flat
								color="error"
								@click="$refs.newItem.close()"
							>
								Close
							</v-btn>
						</v-flex>
					</v-layout>
				</v-form>
			</template>
		</NewItem>
		<UserIterator
			:items="project.users"
			@update="updateUser"
		/>
		<Confirm ref="confirm"/>
	</v-container>
</template>

<script>
import { User } from '@/models/User';
import UserIterator from '@/components/Report/UserIterator';
import NewItem from '@/components/NewItem';
import Confirm from '@/components/Confirm';
import Validation from '@/mixins/Validation';

export default {
	components: {
		UserIterator,
		NewItem,
		Confirm,
	},
	mixins: [Validation],
	data() {
		return {
			show: false,
			valid: true,
			inviteName: '',
			inviteEmail: '',
			sendingInvitation: false,
		};
	},
	created() {
		// Redirect to not found if user doesn't have permission to settings
		/** @todo Improve on global level, good for now */
		this.show = this.project.userCan('manage_users');
		if (!this.show) {
			this.$router.replace({ name: 'NotFound' });
		}
	},
	computed: {
		project() {
			return this.$store.get('projects/currentProject');
		},
	},
	methods: {
		submit() {
			this.sendingInvitation = true;

			const user = new User();
			user.invite(this.project.id, this.inviteName, this.inviteEmail).then((r) => {
				this.$notify('success', `Invitation sent to ${this.inviteName}.`);
				this.$refs.form.reset();
				this.$refs.newItem.close();
				/** @todo Refresh users list if user exists */
			}).catch((e) => {
				dump(e);
				this.$notify('error', 'Error on sending email.');
			}).finally(() => {
				this.sendingInvitation = false;
			});
		},
		updateUser(accessLevel, user) {
			user.access = accessLevel;
			let text = '';
			const userLevel = User.userLevels.find(level => level.value === accessLevel);
			if (userLevel.label) {
				text = `Change ${user.realName}'s access level to "${userLevel.label}"`;
			}

			this.$refs.confirm.createConfirm('Save user changes?', 'success', text).then((answer) => {
				if (!answer) {
					return;
				}
				user.saving = true;
				this.project.updateUser(user.id, user.access).then(() => {
					this.$notify('success', 'User updated.');
				}).catch((e) => {
					dump(e);
					this.$notify('error', 'Error while updating user.');
				}).finally(() => {
					user.saving = false;
				});
			});
		},
	},
};
</script>
